module.exports = __webpack_public_path__ + "assets/records.273562cb.svg";